// extracted by mini-css-extract-plugin
export var cardIcon = "_5t-5";
export var checkboxCard = "_5t-0";
export var checkboxCardSelected = "_5t-4";
export var disabled = "_5t-2";
export var interactive = "_5t-1";
export var outerBorder = "_5t-3";
export var spacerMedium = "_5t-8";
export var spacerSmall = "_5t-7";
export var spacerXsmall = "_5t-6";